enum DictNames {
   rabbit = "rabbit",
   bear = "bear",
   pony = "pony",
   machineGun = "machineGun",
   sniper = "sniper",
   defence = "defence",
   finger = "finger",
   atomic = "atomic",
   bearBoom = "bearBoom",
   mortar = "mortar",
   armageddon = 'armageddon',
   apocalypse = 'apocalypse',
   electric = 'electric',
}

class Dicts {
    [name:string]:MobDict
    public rabbit = {
        name: DictNames.rabbit,
        health:'1d6',
        armor:'1',
        movementSpeed:'3d10/3',
        reloadTimeout:'20',
        attack:'1d20',
        damage:'1d10',
        boomRadius: '-1',
        price: '5',
    }
    
    public bear = {
        name: DictNames.bear,
        health:'3d10',
        armor:'17',
        movementSpeed:'1d6',
        reloadTimeout:'500',
        attack:'20',
        damage:'1d100',
        boomRadius: '80',
        price: '100',
    }
    
    public pony = {
        name: DictNames.pony,
        health:'3d100 + 5000',
        armor:'16',
        movementSpeed:'1',
        reloadTimeout:'20',
        attack:'1d100',
        damage:'1d40',
        boomRadius: '100',
        price: '2000',
    }
    
    public machineGun = {
        name: DictNames.machineGun,
        health:'900 + 2d100',
        armor:'9',
        movementSpeed:'0',
        reloadTimeout:'100',
        attack:'2d9',
        damage:'1d20',
        boomRadius: '-1',
        price: '-500',
        level: 1,
    }
    
    public defence = {
        name: DictNames.defence,
        health:'3000 + 2d100',
        armor:'9',
        movementSpeed:'0',
        reloadTimeout:'10',
        attack:'1d20',
        damage:'1d5',
        boomRadius: '-1',
        price: '-1000',
        level: 1,
    }
    
    public sniper = {
        name: DictNames.sniper,
        health:'900 + 2d100',
        armor:'9',
        movementSpeed:'0',
        reloadTimeout:'200',
        attack:'d30',
        damage:'25',
        boomRadius: '-1',
        price: '-800',
        level: 1,
    }
    public mortar = {
        name: DictNames.mortar,
        health:'900 + 2d100',
        armor:'9',
        movementSpeed:'0',
        reloadTimeout:'400',
        attack:'d20',
        damage:'20',
        boomRadius: '100',
        price: '-3000',
        level: 1,
    }
    
    public finger = {
        name: DictNames.finger,
        health:'100',
        armor:'100',
        movementSpeed:'0',
        reloadTimeout:'0',
        attack:'2d10',
        damage:'1d20',
        boomRadius: '80',
        price: '100',
    }
    
    public armageddon = {
        name: DictNames.armageddon,
        health:'100',
        armor:'100',
        movementSpeed:'0',
        reloadTimeout:'10000',
        attack:'d20',
        damage:'25',
        boomRadius: '80',
        price: '100',
    }
    
    public atomic = {
        name: DictNames.atomic,
        health:'100',
        armor:'100',
        movementSpeed:'0',
        reloadTimeout:'30000',
        attack:'d20',
        damage:'100+d100',
        boomRadius: '300',
        price: '5000',
    }
    
    public electric = {
        name: DictNames.electric,
        health:'100',
        armor:'100',
        movementSpeed:'0',
        reloadTimeout:'60000',
        attack:'1000',
        damage:'1000',
        boomRadius: '300',
        price: '15000',
    }
    
    public apocalypse = {
         name: DictNames.armageddon,
        health:'100',
        armor:'100',
        movementSpeed:'0',
        reloadTimeout:'0',
        attack:'d20',
        damage:'25',
        boomRadius: '80',
        price: '30000',
    }
}